import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'

import signupActions from 'redux/actions/signupActions'
import loginActions from 'redux/actions/loginActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import { signupSelectors } from 'redux/selectors'
import { formValueSelector } from 'redux-form'
import { ssoRedirect } from 'helpers/functions'
import SignupTeacher from 'views/signup/teacher/view'
import SignupStudent from 'views/signup/student/view'

import styles from './signup_main_unified.scss'

class SignupMainUnified extends PureComponent {

	componentDidMount() {
		this.props.actions.getSignupPasswordConditions()
	}

	signupEmailHandler = values => new Promise((resolve, reject) => {
		this.props.actions.sendEmailSignupForm(values, resolve, reject)
	})

	ssoRedirectHandler = service => {
		const url = ssoRedirect(service)
		this.props.actions.ssoRedirect(
			url,
			this.props.isInIframe,
			this.props.fromLTI,
		)
	}

	navigateToOffice = ev => {
		ev.preventDefault()
		this.ssoRedirectHandler('office')
	}

	navigateToGmail = ev => {
		ev.preventDefault()
		this.ssoRedirectHandler('google')
	}

	render() {

		const passwordConditions = this.props.signup.passwordConditions
		if (!passwordConditions) {
			return null
		}

		return (
			<div styleName='wrapper'>
				<div styleName='teacher'>
					<SignupTeacher
						submitHandler={this.signupEmailHandler}
						passwordConditions={passwordConditions}
						form_button_disabled={this.props.form_button_disabled}
						navigateToOffice={this.navigateToOffice}
						navigateToGmail={this.navigateToGmail}
						navigateToLogin={this.props.actions.navigateToLogin}
						navigateToTerms={this.props.actions.navigateToTerms}
					/>
				</div>
				{ this.props.canActAsStudent &&
					<div styleName='student'>
						<SignupStudent />
					</div>
				}
			</div>
		)
	}
}

function mapStateToProps(state) {
	const selector = formValueSelector('SignupForm')
	const recaptcha = selector(state, 'recaptcha')
	return {
		form_button_disabled: !recaptcha,
		...signupSelectors.signupTeacher(state),
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		getSignupPasswordConditions: signupActions.getSignupPasswordConditions,
		sendEmailSignupForm: signupActions.sendEmailSignupForm,
		ssoRedirect: loginActions.ssoRedirect,
		navigateToLogin: loginActions.navigateToLogin,
		navigateToTerms: signupActions.navigateToTerms,
	}, dispatch)
}

SignupMainUnified.propTypes = {
	actions: PropTypes.object,
	signup: PropTypes.shape({
		passwordConditions: PropTypes.object,
	}).isRequired,
	isInIframe: PropTypes.bool,
	fromLTI: PropTypes.bool,
	canActAsStudent: PropTypes.bool,
	form_button_disabled: PropTypes.bool,
}

SignupMainUnified.defaultProps = {
	signup: {
		passwordConditions: null,
	},
	isInIframe: false,
	fromLTI: false,
	canActAsStudent: true,
	form_button_disabled: true,
}

export default connect(mapStateToProps, mapDispatchToProps)(
	CSSModules(SignupMainUnified, styles, {allowMultiple: true})
)
